/**
 * Binance C2C REST API
 *
 * OpenAPI Specification for the Binance C2C REST API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ConfigurationRestAPI, RestApiResponse, sendRequest } from '@binance/common';
import { C2CApi } from './modules/c2-capi';

import type { GetC2CTradeHistoryRequest } from './modules/c2-capi';

import type { GetC2CTradeHistoryResponse } from './types';

export class RestAPI {
    private configuration: ConfigurationRestAPI;
    private c2CApi: C2CApi;

    constructor(configuration: ConfigurationRestAPI) {
        this.configuration = configuration;
        this.c2CApi = new C2CApi(configuration);
    }

    /**
     * Generic function to send a request.
     * @param endpoint - The API endpoint to call.
     * @param method - HTTP method to use (GET, POST, DELETE, etc.).
     * @param params - Query parameters for the request.
     *
     * @returns A promise resolving to the response data object.
     */
    sendRequest<T>(
        endpoint: string,
        method: 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH',
        params: Record<string, unknown> = {}
    ): Promise<RestApiResponse<T>> {
        return sendRequest<T>(this.configuration, endpoint, method, params, undefined);
    }

    /**
     * Generic function to send a signed request.
     * @param endpoint - The API endpoint to call.
     * @param method - HTTP method to use (GET, POST, DELETE, etc.).
     * @param params - Query parameters for the request.
     *
     * @returns A promise resolving to the response data object.
     */
    sendSignedRequest<T>(
        endpoint: string,
        method: 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH',
        params: Record<string, unknown> = {}
    ): Promise<RestApiResponse<T>> {
        return sendRequest<T>(this.configuration, endpoint, method, params, undefined, {
            isSigned: true,
        });
    }

    /**
     * Get C2C Trade History
     *
     * The max interval between startTime and endTime is 30 days.
     * If startTime and endTime are not sent, the recent 7 days' data will be returned.
     * The earliest startTime is supported on June 10, 2020
     * Return up to 200 records per request.
     *
     * Weight: 1
     *
     * @summary Get C2C Trade History (USER_DATA)
     * @param {GetC2CTradeHistoryRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetC2CTradeHistoryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @see {@link https://developers.binance.com/docs/c2c/rest-api/Get-C2C-Trade-History Binance API Documentation}
     */
    getC2CTradeHistory(
        requestParameters: GetC2CTradeHistoryRequest = {}
    ): Promise<RestApiResponse<GetC2CTradeHistoryResponse>> {
        return this.c2CApi.getC2CTradeHistory(requestParameters);
    }
}
